import styled from 'styled-components';
import Select from '../../components/Common/Select';
import Submit from '../components/Submit';
import TimeZoneConnected from '../../components/Common/TimeZone';

export const StyledGoNextMonthButton = styled(Select)`
  margin-top: 10px;
`;

export const StyledTimeZone = styled(TimeZoneConnected)`
  text-align: left;
`;

export const StyledSubmit = styled(Submit)`
  && {
    margin-top: 20px;
  }
`;
